import firebase from "firebase/app";

export interface SigninUserPayload {
  email: string;
  password: string;
}

export interface SignupUserPayload extends SigninUserPayload {
  username: string;
  avatarId: string;
}

export class UserState {
  user: null | firebase.UserInfo = null;
}
